import { api } from 'services/api/baseBackendAPI';

export const personApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Add a person/contact
    addPerson: build.mutation({
      query: (options) => ({
        url: `funds/addPerson`, // Adjust URL as needed
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        if (error) return [];
        return ['Person'];
      },
    }),

    // Get list of people
    getListPeople: build.query({
      query: () => ({
        url: `funds/getListPeoples`,
        method: 'GET',
      }),
      providesTags: ['Person'],
      transformResponse: (response) => {
        return response.data;
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
    }),

    // Get contact details - integrated from your createAsyncThunk
    getContactDetails: build.query({
      query: (requestObject) => ({
        url: `contact-page/get-person-contacts`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: (result, error, requestObject) => {
        if (result?.data?.person_id) {
          return [{ type: 'Person', id: result.data.id }, 'Person'];
        }
        return ['Person'];
      },
      transformResponse: (response) => {
        return { data: response.data, status: response.status };
      },
    }),

    // Get references associated with a contact
    getReferenceContacts: build.query({
      query: (requestObject) => ({
        url: `contact-page/get-Reference-person`,
        method: 'POST',
        data: requestObject,
      }),
      providesTags: ['Person', 'References'],
      transformResponse: (response) => {
        return [...response.data];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useAddPersonMutation,
  useGetListPeopleQuery,
  useGetContactDetailsQuery,
  useGetReferenceContactsQuery,
} = personApi;
